/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliCreateSchoolCycleDto } from '../../models/amoxcalli-create-school-cycle-dto';
import { AmoxcalliSchoolCycleCreatedDto } from '../../models/amoxcalli-school-cycle-created-dto';

export interface ApiCyclesPost$Plain$Params {
      body?: AmoxcalliCreateSchoolCycleDto
}

export function apiCyclesPost$Plain(http: HttpClient, rootUrl: string, params?: ApiCyclesPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliSchoolCycleCreatedDto>> {
  const rb = new RequestBuilder(rootUrl, apiCyclesPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliSchoolCycleCreatedDto>;
    })
  );
}

apiCyclesPost$Plain.PATH = '/api/cycles';
